import { useNewCode } from '@calendly/feature-check-react';
import { useBooleanState } from '@calendly/hooks';
import { buildQuery } from '@calendly/http-tools';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Modal } from '@calendly/ui/components/modal';
import { Sheet } from '@calendly/ui/components/sheet';
import { BodyText, HeadlineText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useCallback, useEffect, useRef, useState, forwardRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { BOOKING_METHODS } from 'features/one_off_modal';
import { useKeyboardShortcut } from 'hooks/useKeyboardShortcut';
import { EventTypesList } from './event_types_list';
import { Footer } from './footer';
import { Header } from './header';
const bodyIsPhoneCss = "bsaga3f";
const bodyCss = "b12p71cv";
const Body = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <Sheet ref={ref} {...props} className={classNames(bodyCss, {
    [bodyIsPhoneCss]: isPhone
  }, props.className)} />;
});
const scrollWrapperCss = "s1n72sgg";
const ScrollWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent = 'div',
    ...restProps
  } = props;
  return <AsComponent ref={ref} {...restProps} className={classNames(scrollWrapperCss, props.className)} />;
});
const oneOffMeetingContainerCss = "o1e94kv4";
const OneOffMeetingContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent = 'div',
    ...restProps
  } = props;
  return <AsComponent ref={ref} {...restProps} className={classNames(oneOffMeetingContainerCss, props.className)} />;
});
const oneOffOptionCss = "o1cn4nyk";
const OneOffOption = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(oneOffOptionCss, props.className)} />);
export const EventTypeSelectPopup = ({
  isOpen,
  onCancel,
  onEventTypeSelect,
  onCreateNewEventType,
  contact,
  defaultValue,
  actionKind = 'share_availability'
}) => {
  const history = useHistory();
  const {
    pathname
  } = useLocation();
  const containerRef = useRef(null);
  const [selectedET, setSelectedET] = useState();
  const [shouldShowStroke, showStroke, hideStroke] = useBooleanState(false);
  const isSingleUseLinkEmptyStateEnabled = useNewCode('qol_sul_empty_state', false)?.enabled;
  const onConfirmSelection = useCallback(() => {
    onEventTypeSelect(selectedET);
    setSelectedET(null);
  }, [onEventTypeSelect, selectedET]);
  const onCloseModal = useCallback(() => {
    setSelectedET(null);
    onCancel();
  }, [onCancel]);
  useEffect(() => {
    setSelectedET(defaultValue);
  }, [defaultValue]);
  useEffect(() => {
    if (isOpen) {
      document.activeElement?.blur();
    }
  }, [isOpen]);
  useKeyboardShortcut('Enter', onConfirmSelection, isOpen, true, () => !!selectedET);
  const handleOneOffMeetingClick = () => {
    const searchStr = buildQuery({
      create_new_meeting: BOOKING_METHODS.instant
    }, {
      addQueryPrefix: true
    });
    history.push({
      search: searchStr
    });
    onCloseModal();
  };
  const handleCreateEventTypeClick = useCallback(event => {
    const isAlreadyOnEventTypesPage = pathname.includes('/scheduling/meeting_types');
    if (isAlreadyOnEventTypesPage) {
      event.preventDefault();
      onCloseModal();
      if (onCreateNewEventType) {
        onCreateNewEventType();
      }
    }
  }, [onCloseModal, onCreateNewEventType, pathname]);
  return <Modal isOpen={isOpen}>
      <Body>
        <Header actionKind={actionKind} onClose={onCloseModal} contact={contact} />
        {isSingleUseLinkEmptyStateEnabled && <OneOffMeetingContainer>
            <OneOffOption onClick={handleOneOffMeetingClick}>
              <HeadlineText size="small" weight="bold">
                {I18n.t('publisher.event_types.share.start_from_scratch')}
              </HeadlineText>
              <BodyText color="muted">
                {I18n.t('publisher.event_types.share.one_off_meeting_help_text')}
              </BodyText>
            </OneOffOption>
          </OneOffMeetingContainer>}
        <ScrollWrapper ref={containerRef}>
          <EventTypesList onSelect={et => {
          setSelectedET(et);
        }} selectedET={selectedET} actionKind={actionKind} showStroke={showStroke} hideStroke={hideStroke} onCreateEventTypeClick={handleCreateEventTypeClick} ref={containerRef} isOpen />
        </ScrollWrapper>
        <Footer onConfirm={onConfirmSelection} onCancel={onCloseModal} hasSelected={!!selectedET} withStroke={shouldShowStroke} />
      </Body>
    </Modal>;
};

require("./event_type_select_popup.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./event_type_select_popup.js");